import clientLocalStorage from '@/utilities/clientLocalStorage'

const previousTriggerData = `previous-trigger-data`

export const clearLocalStorageTriggerData = (featureId: string) => {
  clientLocalStorage.removeItem(`${previousTriggerData}-${featureId}`)
}

export const fetchLocalStorageTriggerData = (featureId: string) => {
  return clientLocalStorage.getItem(`${previousTriggerData}-${featureId}`)
}

export const setLocalStorageTriggerData = (featureId: string, value: any) => {
  clientLocalStorage.setItem(`${previousTriggerData}-${featureId}`, value)
}
